export default "__VITE_ASSET__B039$XaO__"